package com.routexk.quiz.ui.theme

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*

object AppTypography {

    // RouteXK funnel design system: Inter for text/headings, Open Sans for buttons/inputs
    const val PRIMARY_FONT_NAME = "Inter"
    const val PRIMARY_FONT_FALLBACK = "sans-serif"
    const val SECONDARY_FONT_NAME = "Inter"
    const val SECONDARY_FONT_FALLBACK = "sans-serif"
    const val TERTIARY_FONT_NAME = "Open Sans"
    const val TERTIARY_FONT_FALLBACK = "sans-serif"
    const val QUATERNARY_FONT_NAME = "Montserrat"
    const val QUATERNARY_FONT_FALLBACK = "sans-serif"

    val H1 = 48.px
    val H2 = 36.px
    val H3 = 28.px
    val H4 = 24.px
    val H5 = 20.px
    val H6 = 18.px
    val Body = 16.px
    val BodySmall = 14.px
    val Caption = 12.px
    val Overline = 10.px

    val Light = 300
    val Regular = 400
    val Medium = 500
    val SemiBold = 600
    val Bold = 700

    val Tight = 1.2
    val Normal = 1.5
    val Relaxed = 1.75
}

fun Modifier.h1(): Modifier = this
    .fontSize(AppTypography.H1)
    .fontWeight(AppTypography.Bold)
    .lineHeight(AppTypography.Tight)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)

fun Modifier.h2(): Modifier = this
    .fontSize(AppTypography.H2)
    .fontWeight(AppTypography.Bold)
    .lineHeight(AppTypography.Tight)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)

fun Modifier.h3(): Modifier = this
    .fontSize(AppTypography.H3)
    .fontWeight(AppTypography.SemiBold)
    .lineHeight(AppTypography.Tight)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)

fun Modifier.h4(): Modifier = this
    .fontSize(AppTypography.H4)
    .fontWeight(AppTypography.SemiBold)
    .lineHeight(AppTypography.Normal)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)

fun Modifier.body(): Modifier = this
    .fontSize(AppTypography.Body)
    .fontWeight(AppTypography.Regular)
    .lineHeight(AppTypography.Normal)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)

fun Modifier.bodySmall(): Modifier = this
    .fontSize(AppTypography.BodySmall)
    .fontWeight(AppTypography.Regular)
    .lineHeight(AppTypography.Normal)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)

fun Modifier.caption(): Modifier = this
    .fontSize(AppTypography.Caption)
    .fontWeight(AppTypography.Regular)
    .lineHeight(AppTypography.Normal)
    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
